import store from '@/store/index.js'

// 请求的前缀（包括静态资源）
export const requestPrefix = process.env.VUE_APP_URLKEY;

export const urlPreFix=process.env.VUE_APP_URL;

// 二维码地址
export const QR_CODE_URL = process.env.VUE_APP_QR_CODE_URL;
// webSocket地址
export const SOCKET_URL = process.env.VUE_APP_SOCKET_URL;
export const USER_NAME = process.env.VUE_APP_USER_NAME;
export const USER_PASSWORD = process.env.VUE_APP_USER_PASSWORD;

export function deepClone(obj) { // 尝试克隆
  let isArr = Array.isArray(obj);
  let isJson = Object.prototype.toString.call(obj) === '[object Object]';
  if (isArr) {
    // 克隆数组
    let newObj = [];
    for (let i = 0; i < obj.length; i++) {
      newObj[i] = deepClone(obj[i]);
    }
    return newObj;
  } else if (isJson) {
    // 克隆Object
    let newObj = {};
    for (let i in obj) {
      newObj[i] = deepClone(obj[i]);
    }
    return newObj;
  }
  // 不是引用类型直接返回
  return obj;
}

// 数组生成对象
export function arrToObj(arr, key = 'id') {
  let result = {};
  arr.forEach(e => result[e[key]] = e);
  return result;
}

// 数组生成对象,以key的值为键，以valueKey的值为值
export function arrToValueKeyObj(arr, key = 'id', valudKey = 'name') {
  let result = {};
  arr.forEach(e => result[e[key]] = e[valudKey]);
  return result;
}

// 数组生成树， objArr: 对象数组，key：对象的唯一键，parentKey：对象父key
export function objArrayToTree(objArr, key = 'id', parentKey = 'pid') {
  let obj = {};
  let result = [];
  objArr.forEach(o => {
    obj[o[key]] = o;
  });
  objArr.forEach(o => {
    if (o[parentKey]) {
      if (obj[o[parentKey]]) {
        if (!obj[o[parentKey]].children) {
          obj[o[parentKey]].children = [];
        }
        obj[o[parentKey]].children.push(o);
      } else {
        result.push(o)
      }
    } else {
      result.push(o);
    }
  });
  return result;
}

// utils/utils.js
// 将el-icon的组件名称AbbbCddd转化为i-abbb-cddd形式
// 此前用switch做组件名时因关键字重复报错，所以格式统一加了前缀
// 例：Switch转换为i-switch，ArrowDownBold转换为i-arrow-down-bold
export function transElIconName(iconName){
  return 'i'+iconName.replace(/[A-Z]/g,(match)=>'-'+match.toLowerCase())
}

/** 通过文件路径生成文件访问地址 */
export function getFileUrl(filePath) {
  return encodeURI(`${requestPrefix}/enterpriseWx/downLoadFile?filePath=${filePath}&accessToken=${store.getters.accessToken}`)
}
/**
 * 获取shorUUID
 * @returns 
 */
export function generatorShortUUID() {
  var mydate = new Date();
  return mydate.getSeconds() + "" + mydate.getMilliseconds() + "" + mydate.getTime();
}

/**
 * 判断是否在权限
 */
export function isHavePower(powerId) {
  return store.getters.powersObj[powerId] !== undefined;
}

/**
 * 判断权限是否在企业管理员权限中
 */
 export function isHaveOrgPower(powerId) {
  return store.getters.orgPowersObj[powerId] !== undefined;
}